import React from "react";
import { useNxTranslation } from "./useNxTranslation";
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
// TODO remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withNxTranslation = (WrappedComponent) => {
    const forwardRef = (props, ref) => {
        const t = useNxTranslation();
        return React.createElement(WrappedComponent, Object.assign({ ref: ref }, t, props));
    };
    forwardRef.displayName = `withNxTranslation(${getDisplayName(WrappedComponent)})`;
    return React.forwardRef(forwardRef);
};
export default withNxTranslation;
//# sourceMappingURL=withNxTranslation.js.map